<template>
  <div>
    <ConfigListItem
      label="Odômetro"
      :value="strValue"
      :date="maxUpdatedAt"
      :login="maxUpdatedBy"
      @click="openEditDialog"
    />

    <ODialog ref="dialog" :max-width="800">
      <v-card>
        <ODialogBar title="Origem do Odômetro" @close="dismiss" />
        <v-card-text v-if="readonly" class="pa-6">
          <p>
            O valor da configuração "Uso da Serial" está 0x03 ou 0x04, o que
            impede a alteração desta configuração.
          </p>
          <p>
            Entre em contato com o time de desenvolvimento para corrigir.
          </p>
        </v-card-text>
        <v-card-text v-else class="pa-6">
          <div class="d-flex align-start">
            <OVerticalTabs
              class="mr-6"
              v-model="clonedValues.odoSource"
              :tabs="[
                { value: 'sensor', text: 'Sensor' },
                { value: 'can', text: 'CAN' }
              ]"
            />
            <v-tabs-items class="flex-grow-1" v-model="clonedValues.odoSource">
              <div class="px-4" v-if="clonedValues.odoSource == null">
                Escolha um valor da lista ao lado.
              </div>

              <v-tab-item value="sensor" class="px-4">
                <OTextField
                  v-model.number="clonedValues.odometerConstant"
                  label="Valor da constante"
                />
              </v-tab-item>

              <v-tab-item value="can" class="px-4">
                <SelectCANVariable
                  :canDictId="canDictId"
                  v-model="clonedValues.odoCanVariable"
                />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-card-text>
        <ODialogButtons
          v-if="!readonly"
          class="pa-6"
          txtApply="Salvar"
          @cancel="dismiss"
          @apply="save"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import ConfigListItem from './ConfigListItem.vue'
import {
  mostRecentlyUpdated,
  decHex,
  getCfg,
  getManyCfgs
} from './config-utils.js'
import OVerticalTabs from './OVerticalTabs.vue'
import SelectCANVariable from './SelectCANVariable.vue'

// usado aqui e na tela de cópia de configs
export function displayValue(allConfigs) {
  let cfgs = getManyCfgs(
    allConfigs,
    'odoSource',
    'odometerConstant',
    'odoCanVariable'
  )
  switch (cfgs.odoSource) {
    case 'sensor': {
      let x = cfgs.odometerConstant
      return `Sensor odometerConstant=${decHex(x)}`
    }
    case 'can': {
      let y = cfgs.odoCanVariable
      return `CAN variable=${y && y.code}`
    }
    default:
      return '???'
  }
}

export function copyValue(allConfigs) {
  return getManyCfgs(
    allConfigs,
    'odoSource',
    'odometerConstant',
    'odoCanVariable'
  )
}

export default {
  components: { ConfigListItem, OVerticalTabs, SelectCANVariable },
  props: {
    vehicle: { required: true },
    allConfigs: { required: true }
  },
  data() {
    return {
      clonedValues: { odoSource: 'sensor' }
    }
  },
  computed: {
    readonly() {
      let x = getCfg(this.allConfigs, 'uso-da-serial')
      return x == '0x03' || x == '0x04'
    },
    canDictId() {
      return getCfg(this.allConfigs, 'canDictId')
    },
    strValue() {
      return displayValue(this.allConfigs)
    },
    mostRecent() {
      return mostRecentlyUpdated(
        this.allConfigs,
        'odoSource',
        'odometerConstant',
        'odoCanVariable'
      )
    },
    maxUpdatedAt() {
      return this.mostRecent && this.mostRecent.updatedAt
    },
    maxUpdatedBy() {
      return this.mostRecent && this.mostRecent.updatedBy
    }
  },
  methods: {
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    openEditDialog() {
      this.clonedValues = getManyCfgs(
        this.allConfigs,
        'odoSource',
        'odometerConstant',
        'odoCanVariable'
      )
      return this.$refs.dialog.$open()
    },
    async save() {
      const payload = this.clonedValues
      this.$emit('save', payload)
      this.dismiss()
    }
  }
}
</script>

<style></style>
